"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.article(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  flex: 0 0 auto;\n  width: 184px;\n  height: 40px;\n  border-radius: 4px;\n  background: ", ";\n  font-family: ", ";\n  color: ", ";\n  align-items: center;\n  padding: 0px 8px 0px 12px;\n  cursor: pointer;\n  border: 1px solid transparent;\n\n  &.disabled {\n    background: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  &.filled {\n    background: ", ";\n  }\n\n  &.active {\n    border-color: ", ";\n    background: ", ";\n  }\n\n  &.invalid {\n    border-color: ", ";\n    color: ", ";\n    background: ", ";\n  }\n\n  &:hover:not(.disabled):not(.active):not(.invalid) {\n    background: ", ";\n    color: ", ";\n  }\n\n  .value {\n    display: flex;\n    flex: 1 1 0%;\n    font-size: 16px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    margin: 0 5px 0 0;\n    color: ", ";\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    pointer-events: none;\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  position: relative;\n  flex: 0 0 auto;\n  width: 184px;\n  height: 40px;\n  border-radius: 4px;\n  background: ", ";\n  font-family: ", ";\n  color: ", ";\n  align-items: center;\n  padding: 0px 8px 0px 12px;\n  cursor: pointer;\n  border: 1px solid transparent;\n\n  &.disabled {\n    background: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  &.filled {\n    background: ", ";\n  }\n\n  &.active {\n    border-color: ", ";\n    background: ", ";\n  }\n\n  &.invalid {\n    border-color: ", ";\n    color: ", ";\n    background: ", ";\n  }\n\n  &:hover:not(.disabled):not(.active):not(.invalid) {\n    background: ", ";\n    color: ", ";\n  }\n\n  .value {\n    display: flex;\n    flex: 1 1 0%;\n    font-size: 16px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    margin: 0 5px 0 0;\n    color: ", ";\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    pointer-events: none;\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map